import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SideMenuComponent } from './side-menu.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [SideMenuComponent],
  imports: [CommonModule, SharedModule, MatTooltipModule],
  exports: [SideMenuComponent],
})
export class SideMenuModule {}
